




















































import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { getTagColor } from '~/utils/solepro/products';
import { ProductBox } from '~/utils/types/Product';
import Spinner from '~/components/solepro/Spinner.vue';
import { addBasePath } from "~/helpers/addBasePath";
import ProductBoxPrice from './ProductBoxPrice.vue';
import ClientOnly from 'vue-client-only';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductBox>,
            required: true
        },
        classes: {
            type: Object,
            default: () => { return {} }
        },
        trackCard: {
            type: Function
        },
        hideBoxDescription: {
            default: false
        },
        showLoader: {
            default: false
        },
        isLazyLoading: {
            type: Boolean,
            default: false
        },
        pricesData: {
            type: Object,
            default: () => { return {} }
        },
        pricetag: {
            type: String,
            default: 'h3'
        }
    },
    components: {
        Spinner,
        ProductBoxPrice,
        ClientOnly
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup(props) {
        const { config } = useConfig();
        const {app } = useContext()
        const storeCode = config.value.store_code;
        const placeholderImage = addBasePath('/resources/productpage/solepro/product-placeholder.png');

        const trackCardEvent = async () => {
            if (props.trackCard) {
                await props.trackCard(props.product.name)
            }
            location.href = `/${storeCode}/${props.product.url_key + props.product.url_suffix}`;

        }
        return {
            getTagColor,
            trackCardEvent,
            storeCode,
            topics: props.product.topics.slice(0, 2),
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
            placeholderImage
        }
    }
})
